import { defineStore } from "pinia";

export const useUiStore = defineStore("uiStore", {
  state: () => {
    return {
      pageLoader: false,
      menushow: false,
      avisoWidth: false,
    };
  },
  actions: {
    setPageLoader(value) {
      this.pageLoader = value;
    },
    toogleMenu() {
      this.menushow = !this.menushow;
    },
    menuClose() {
      this.menushow = false;
    },
    toogleAvisoWidth() {
      this.avisoWidth = !this.avisoWidth;
    }
  },
  persist: true,
});
